class Handlers {

    static execute_js(params) {
        eval(params.value);
    }

    static reload(params) {
        window.location.reload();
    }

    static redirect(params) {
        window.location = params.value;
    }

    static toast(params) {
        toastr[params.level](params.value);
    }

    static open_modal(params) {
        let $modal = $(params.value);
        let $opened_modal = $('.js-umbrella-modal.show');

        if ($opened_modal.length) {
            $opened_modal.html($modal.find('.modal-dialog'));
            Kernel.mountComponents($opened_modal);

        } else {

            // HACK : bs 4 modal doesn't execute script
            $modal.on('shown.bs.modal', (e) => {
                Kernel.mountComponents($(e.target));
                const $scripts = $(e.target).find('script');
                $.each($scripts, (i, s) => {
                    eval($(s).html());
                });
            });
            $modal.on('hidden.bs.modal', (e) => {
                $(e.target).data('bs.modal', null);
                $(e.target).remove();
            });
            $("body").append($modal);
            $modal.addClass("show").css("display","block");
            window.Kernel.mountComponents($('body'));
//            $modal.modal('show');

        }
    }

    static close_modal(params) {
        let $opened_modal = $('.modal.show');
        if ($opened_modal.length) {
            $opened_modal.removeClass('show');
        }
    }

    static reload_table(params) {
        let component = Kernel.getComponent(params.id);
        if (component){
            component.reload(false);
        } else {
            console.warn('No component found with id ' + params.id);
        }
    }

    static reload_tree(params) {
        let component = Kernel.getComponent(params.id);
        if (component){
            component.reload();
        } else {
            console.warn('No component found with id ' + params.id);
        }
    }

    static update(params) {
        const $node = $(params.selector);
        $node.html(params.value);
        Kernel.mountComponents($node);
    }

    static remove(params) {
        $(params.selector).remove();
    }

}

module.exports = Handlers;


// WEBPACK FOOTER //
// ./public/frontend/js/components/appproxy/Handlers.js